import { setApiClient } from '@roko/api/mutator'

import { privateClient } from '@/data/api/clients/privateClient'
import { publicClient } from '@/data/api/clients/publicClient'
import { authInterceptor } from '@/data/api/interceptors/request/authInterceptor'
import { errorInterceptor } from '@/data/api/interceptors/response/errorInterceptor'
import { loggerInterceptor } from '@/data/api/interceptors/response/loggerInterceptor'

const registerClientInterceptors = () => {
  const clients = [publicClient, privateClient]

  clients.forEach((client) => {
    client.interceptors.request.use(authInterceptor)
    client.interceptors.request.use(loggerInterceptor.request)
    client.interceptors.response.use(loggerInterceptor.response, loggerInterceptor.responseError)
  })

  privateClient.interceptors.response.use(undefined, errorInterceptor)
  publicClient.interceptors.response.use(undefined, errorInterceptor)

  setApiClient(privateClient)
}

registerClientInterceptors()
